export const learnMoreDccUrl = 'https://dnapayments.com/our-services/dynamic-currency-conversion'
